import { FC } from 'react';
import { Version } from './Version/Version';

export const VersionPage: FC = () => {
  return <Version />;
};
